<script>
    import { apiMethods } from "../../../Services/index.svelte";

    import {
        showError,
        showException,
    } from "../../../Utils/utilFunctions.svelte";
    import PatientEncounterEmailTemplatesTable from "../../PatientEncounter/components/PatientEncounterEmailTemplatesTable.svelte";
    import PatientEncounterSmsTemplatesTable from "../../PatientEncounter/components/PatientEncounterSmsTemplatesTable.svelte";
    import AccountPushNotificationTable from "./AccountPushNotificationTable.svelte";

    export let accountId;

    let isLoading = false;

    let emailNotifications = [],
        smsNotifications = [],
        pushNotifications = [];

    let scrollableContainerRef;

    export const init = () => loadAccountComms();

    const loadAccountComms = async () => {
        if (!accountId) return showError("Doctor ID Missing");
        isLoading = true;

        await apiMethods.getMethod
            .getAccountNotifications(accountId, { limit: 50 })
            .then((res) => {
                if (res.error) return showError(res.error);

                emailNotifications = res.emailNotifications;
                smsNotifications = res.smsNotifications;
                pushNotifications = res.pushNotifications;
            })
            .catch((err) => showException(err));

        isLoading = false;
    };
</script>

<div class="relative flex-1">
    <div
        class="flex flex-col overflow-y-auto absolute inset-0 gap-4 m-4"
        bind:this={scrollableContainerRef}
        use:init
    >
        <PatientEncounterEmailTemplatesTable
            {emailNotifications}
            commsDoctorId={accountId}
            reloadCommunication={loadAccountComms}
            isInDoctor
            {scrollableContainerRef}
        />

        <PatientEncounterSmsTemplatesTable
            {smsNotifications}
            commsDoctorId={accountId}
            reloadCommunication={loadAccountComms}
            isInDoctor
            {scrollableContainerRef}
        />

        <AccountPushNotificationTable
            {pushNotifications}
            commsDoctorId={accountId}
            reloadCommunication={loadAccountComms}
            {scrollableContainerRef}
        />
    </div>
</div>
